// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {getTransferResults} from '../../shared/repositories';

export const updateTransferResults = query =>
dispatch => {

    dispatch({
        type: actions.INCREASE_BUSY_COUNTER
    });

    return getTransferResults(query)
            .then(data => {

                dispatch({
                    type: actions.DECREASE_BUSY_COUNTER
                });

                dispatch({
                    data,
                    type: actions.UPDATE_TRANSFER_RESULTS
                });

            })
            .catch(() => {

                dispatch({
                    type: actions.DECREASE_BUSY_COUNTER
                });

            });

};



// WEBPACK FOOTER //
// ./src/product/transfers/action-creators/search.js